import { render, staticRenderFns } from "./warning-cell.vue?vue&type=template&id=3dbda72c&scoped=true"
import script from "./warning-cell.vue?vue&type=script&lang=js"
export * from "./warning-cell.vue?vue&type=script&lang=js"
import style0 from "./warning-cell.vue?vue&type=style&index=0&id=3dbda72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbda72c",
  null
  
)

export default component.exports